import React from "react";
import { GenericDialog } from "components/common/dialogs/GenericDialog";
import ConsentCheckboxes from "components/common/consent/ConsentCheckboxes";
import ConsentDetailContent from "components/common/consent/ConsentDetailContent";
import ConsentPreferencesContent from "components/common/consent/ConsentPreferencesContent";
import { useConsentForm } from "lib/hooks/useConsentForm";

/**
 * DPDPA consent for the checkout and cart login screens: the main and marketing
 * checkboxes, with Manage preferences and Read more as sheets stacked over the page.
 * Renders nothing unless the merchant enforces consent and the shopper is logged out.
 */
const DPDPAConsent: React.FC<{ className?: string }> = ({ className }) => {
  const consentForm = useConsentForm();
  const {
    isVisible,
    visibleConsents,
    isPreferencesOpen,
    draft,
    closePreferences,
    changeDraft,
    savePreferences,
    detailConsent,
    openDetail,
    closeDetail,
  } = consentForm;

  if (!isVisible) return null;

  return (
    <>
      <ConsentCheckboxes consentForm={consentForm} className={className} />

      <GenericDialog
        isOpen={isPreferencesOpen}
        setIsOpen={(open) => !open && closePreferences()}
        translateAxis="y"
        customClass="h-auto rounded-t-3xl"
        closeOnOverlayClick={true}
        // Read more stacks on top; its sheet covers this one, so the close button goes too.
        showExternalClose={!detailConsent}>
        <ConsentPreferencesContent
          consents={visibleConsents}
          answers={draft}
          onChange={changeDraft}
          onReadMore={openDetail}
          onSave={savePreferences}
          // Kept below Read more's height so Read more always stacks visibly taller.
          maxHeightClassName="max-h-[80vh]"
        />
      </GenericDialog>

      <GenericDialog
        isOpen={Boolean(detailConsent)}
        setIsOpen={(open) => !open && closeDetail()}
        translateAxis="y"
        customClass="h-auto rounded-t-3xl pt-0"
        closeOnOverlayClick={true}>
        {detailConsent && <ConsentDetailContent consent={detailConsent} onBack={closeDetail} />}
      </GenericDialog>
    </>
  );
};

export default DPDPAConsent;
